import type { ElementType } from 'react';

import { S } from './IconButton.styles';
import type { IconButtonProps } from './IconButton.types';

export const IconButton = <C extends ElementType = 'button'>({
  corner = 'pill',
  variant = 'filled',
  ...otherProps
}: IconButtonProps<C>) => <S.Button corner={corner} variant={variant} {...otherProps} />;
